import React from 'react';
import OutlinedInput from '@material-ui/core/OutlinedInput';

import NumberFormat from 'react-number-format';

function OutlineFormattedTextField(props) {
    return (
        <OutlinedInput
            margin="none"
            variant="outlined"
            color="secondary"
            labelWidth={0}
            onChange={props.onChange}
            onBlur={props.onChange}
            inputComponent={NumberFormatCustom}
            inputProps={{
                ...props.inputProps
            }}            
            {...props}
        />
    ); 
}

function NumberFormatCustom(props) {
    const { inputRef, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
      />
    );
  }
  
export default OutlineFormattedTextField;